/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import DeviceCreationBtn from '../views/device/DeviceCreationBtn';
import DevicesList from '../views/device/DevicesList';

const ManageDevicesPage = () => {


    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Device'} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} />

                    <Grid item xs={12} sm={6} md={6} >
                        <DeviceCreationBtn />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <DevicesList />
                    </Grid>

                </Grid>
            </Box>

        </>
    )

}

export default ManageDevicesPage;
